<template>
  <div v-if="isShow" class="group-button-bottom">
    <a class="btn-bottom btn-register" :href="signupUrl">Đăng Ký</a>
    <a class="btn-bottom btn-login" :href="homeUrl">Đăng Nhập</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      signupUrl: "",
      homeUrl: "",
    }
  },
  mounted() {
    const { token, signupurl, homeurl } = this.$router.currentRoute.query;
    if((token === "" || token === undefined) 
      && signupurl !== "" && signupurl !== undefined && signupurl !== null
      && homeurl !== "" && homeurl !== undefined && homeurl !== null
    ){
      this.signupUrl = signupurl;
      this.homeUrl = homeurl;
      this.isShow = true;
    }
  },
}
</script>

<style>

</style>

